module.exports = __webpack_public_path__ + "img/sld_isolator_r1_l1_dark.b8b4a325.svg";